/* eslint-disable */
function isVisible(element, vp) {
  if (element) {
    var rect = element.getBoundingClientRect();
    // var x = rect.left;
    // var x2 = x + element.offsetWidth;
    var y = rect.top;
    var y2 = y + element.offsetHeight;
    return !(y >= vp.h || y2 < 0);
  } else {
    return null;
  }
}
function viewport(scrollElement) {
  // this.x = window.pageXOffset;
  // this.w = window.innerWidth;
  // this.x2 = this.x + this.w - 1;
  this.y = scrollElement ? scrollElement.scrollTop : window.pageYOffset;
  this.h = scrollElement ? scrollElement.clientHeight : window.innerHeight;
  this.y2 = this.y + this.h;
  return this;
}
function fetchVisibleItems(blocks, scrollElement, topThreshold = 160) {
  var vp = new viewport(scrollElement);
  var from = 0; //hack -- Priya
  var to = blocks.length; //hack -- Priya
  var array = [];
  for (var b = from; b < to; ++b) {
    var block = blocks[b];
    if (isVisible(block, vp)) {
      if (block.getBoundingClientRect().top > topThreshold) {
        array.push(blocks[b - 1]);
      } else {
        array.push(block);
      }
    }
  }
  return array;
}
export default fetchVisibleItems;
